import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Loader2, ChevronRight } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const CAT_COLOR = {
  seafood: "text-sky-400",
  game: "text-orange-500",
  poultry: "text-yellow-400",
  offal: "text-orange-400",
  vegetable: "text-lime-400",
  fruit: "text-pink-400",
  herb: "text-lime-400",
  dairy: "text-amber-200",
  grain: "text-amber-400",
  other: "text-stone-400",
};

const Ingredients = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/ingredients").then((r) => setItems(r.data)).catch(() => setItems([])).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen pt-24 pb-32 bg-stone-950">
      <div className="max-w-[1600px] mx-auto px-6 sm:px-10">
        <div className="mb-12 border-b border-stone-800 pb-10">
          <div className="flex items-center gap-4 mb-6">
            <span className="magazine-number text-5xl">07</span>
            <div className="w-16 h-px bg-orange-600" />
            <span className="eyebrow">The Larder</span>
          </div>
          <h1 className="font-serif-display text-6xl md:text-7xl text-stone-100 leading-[0.9] tracking-tighter">
            Know your <span className="italic text-orange-600">ingredients</span>.
          </h1>
          <p className="mt-8 text-stone-300 max-w-2xl leading-relaxed">
            Short, honest deep-dives on the hero ingredients &mdash; when to buy them, where to find them, how to treat them right.
          </p>
        </div>
        {loading ? (
          <div className="flex items-center justify-center py-32"><Loader2 className="w-6 h-6 animate-spin text-orange-600" /></div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((ing) => {
              const heroImg = ing.image_status === "ready" ? `${BACKEND}/api/ingredients/${ing.slug}/og_image` : null;
              return (
                <Link
                  key={ing.id}
                  to={`/ingredients/${ing.slug}`}
                  data-testid={`ingredient-card-${ing.slug}`}
                  className="group block border border-stone-800 bg-stone-900/40 hover:border-orange-700 transition-colors"
                >
                  <div className="aspect-[4/3] overflow-hidden bg-stone-900">
                    {heroImg ? (
                      <img src={heroImg} alt={ing.name} className="w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-[1.04]" />
                    ) : (
                      <div className="w-full h-full bg-gradient-to-br from-stone-900 via-stone-950 to-stone-900 flex items-center justify-center">
                        <span className="font-serif-display italic text-sm text-stone-500">Photograph on its way</span>
                      </div>
                    )}
                  </div>
                  <div className="p-6 space-y-3">
                    <div className={`eyebrow ${CAT_COLOR[ing.category] || "text-stone-400"}`}>{ing.category}</div>
                    <h3 className="font-serif-display text-3xl leading-tight text-stone-100 group-hover:text-orange-500 transition-colors">{ing.name}</h3>
                    <p className="text-sm text-stone-400 italic">{ing.tagline}</p>
                    <div className="pt-2 flex items-center justify-end">
                      <ChevronRight className="w-4 h-4 text-stone-500 group-hover:text-orange-500 transition-colors" />
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default Ingredients;
